var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center mr-4 text-indigo-400 cursor-pointer md:mr-10 hover:text-indigo-600"},[_c('div',{staticClass:"w-4 h-4 sm:h-6 sm:w-6",on:{"click":function($event){return _vm.handle('closeView')}}},[_c('close-icon',{attrs:{"type":"outline"},on:{"click":function($event){return _vm.handle('closeView')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }